<template>

  <div>

    <pegawai-add
        :is-add-sidebar-active.sync="isAddSidebarActive"
        :pengawasOptions="pengawasOptions"
        :bidangOptions="bidangOptions"
        :pengawas="pengawas"
        @refetch-data="refetchData"
    />

    <!-- Filters -->
    <pegawai-filter
        v-show="filter"
        :pengawas="pengawas"
        :pengawasOptions="pengawasOptions2"
        :pengawas-filter.sync="pengawasFilter"
        :bidangOptions="bidangOptions"
        :bidang-filter.sync="bidangFilter"
        :unitKerjaOptions="unitKerjaOptions"
        :unit-kerja-filter.sync="unitKerjaFilter"
        :user="user"
    />

    <!-- Table Container Card -->
    <b-card
        no-body
        class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Tampilkan</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>data</label>
          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
              />
              <b-button
                  variant="primary"
                  @click="isAddSidebarActive = true"
              >
                <span class="text-nowrap">Tambah Pegawai</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetch"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Tidak ada data"
          :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Nama -->
        <template #cell(nama)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                  size="32"
                  :src="data.item.picture"
                  :variant="`light-primary`"
                  :to="{ name: 'pegawai-detail', params: { id: data.item.id } }"
              />
            </template>
            <b-link
                :to="{ name: 'pegawai-detail', params: { id: data.item.id } }"
                class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.nama }}
            </b-link>
            <small class="text-muted"> NIP : {{ data.item.nip }}</small>
          </b-media>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
              />
            </template>

            <b-dropdown-item :to="{ name: 'pegawai-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon"/>
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click.prevent="destroy(data.item.id)">
              <feather-icon icon="TrashIcon"/>
              <span class="align-middle ml-50">Hapus</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Menampilkan {{ dataMeta.from }} sampai {{ dataMeta.to }} dari {{ dataMeta.of }} data</span>
          </b-col>
          <!-- Pagination -->
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {ref, onUnmounted} from '@vue/composition-api'
import {avatarText} from '@core/utils/filter';
import pegawaiFilter from './PegawaiFilter'
import pegawaiList from './PegawaiList'
import pegawaiStoreModule from './PegawaiStoreModule'
import pegawaiAdd from './PegawaiAdd.vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  components: {
    pegawaiFilter,
    pegawaiAdd,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,


    vSelect,
  },
  computed: {
    user() { return this.$store.getters.user },
  },
  props: {
    filter: {
      type: Boolean,
      default: true,
      required: false
    },
    pengawas: {
      type: Object,
      required: false
    }
  },
  setup(props) {
    const PEGAWAI_APP_STORE_MODULE_NAME = 'app-pegawai'

    // Register module
    if (!store.hasModule(PEGAWAI_APP_STORE_MODULE_NAME)) store.registerModule(PEGAWAI_APP_STORE_MODULE_NAME, pegawaiStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PEGAWAI_APP_STORE_MODULE_NAME)) store.unregisterModule(PEGAWAI_APP_STORE_MODULE_NAME)
    })

    const isAddSidebarActive = ref(false)

    const {
      fetch,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,

      refetchData,
      // Filter

      //Extra Filter
      pengawasFilter,
      bidangFilter,
      unitKerjaFilter
    } = pegawaiList()

    const pengawasOptions = []
    const pengawasOptions2 = []
    const bidangOptions = []
    const unitKerjaOptions = []

    return {
      // Sidebar
      isAddSidebarActive,

      fetch,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      avatarText,

      // UI
      pengawasOptions,
      pengawasOptions2,
      bidangOptions,
      unitKerjaOptions,

      // Extra Filters
      pengawasFilter,
      bidangFilter,
      unitKerjaFilter
    }
  },
  methods: {
    pengawasOptionsGetters() {
      store
          .dispatch('app-pegawai/pengawas', {
            perPage: 1000,
          })
          .then(response => {
            const data2 = []
            const data = []
            if(this.user.type === 'Pengawas'){
              for (let key in response.data.data.data) {
                if(this.user.id === response.data.data.data[key].id ){
                  data.push({
                    'label': response.data.data.data[key].nama,
                    'value': response.data.data.data[key],
                  });
                  data2.push({
                    'label': response.data.data.data[key].nama,
                    'value': response.data.data.data[key].id,
                  });
                }
              }
              this.pengawasFilter = this.user.id
            }else{
              for (let key in response.data.data.data) {
                data.push({
                  'label': response.data.data.data[key].nama,
                  'value': response.data.data.data[key],
                });
                data2.push({
                  'label': response.data.data.data[key].nama,
                  'value': response.data.data.data[key].id,
                });
              }
            }
            this.pengawasOptions = data
            this.pengawasOptions2 = data2
          })
          .catch((error) => {
            console.log(error)
          })
    },
    bidangOptionsGetters() {
      store
          .dispatch('app-pegawai/bidang', {
            perPage: 1000,
          })
          .then(response => {
            const data = []
            for (let key in response.data.data.data) {
              data.push({
                'label': response.data.data.data[key].nama,
                'value': response.data.data.data[key].id,
              });
            }
            this.bidangOptions = data
          })
          .catch((error) => {
            console.log(error)
          })
    },
    unitKerjaOptionsGetters() {
      store
          .dispatch('app-pegawai/unitkerja', {
            perPage: 1000,
            kategori : this.user === 'Pengawas' ? this.user.kategori_id : null
          })
          .then(response => {
            const data = []
            for (let key in response.data.data.data) {
              data.push({
                'label': response.data.data.data[key].nama,
                'value': response.data.data.data[key].id,
              });
            }
            this.unitKerjaOptions = data
          })
          .catch((error) => {
            console.log(error)
          })
    },
    destroy(id) {
      this.$swal({
        title: 'Apa anda yakin akan menghapus Pegawai?',
        text: "Data Presensi di bawah pengawas ini akan ikut di hapus!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, hapus!',
        cancelButtonText: 'Tidak',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-pegawai/destroy', id)
              .then(() => {
                this.$swal({
                  icon: 'success',
                  title: 'Terhapus!',
                  text: 'Data pegawai berhasil di hapus.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.refetchData()
              })
        }
      })
    }
  },
  created() {
    this.pengawasOptionsGetters()
    this.bidangOptionsGetters()
    this.unitKerjaOptionsGetters()
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
